import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@qaroni-app/auth/types/user';
import { Company } from '@qaroni-app/company/types/company';
import { DashboardStorageService } from '@qaroni-app/dashboard/services/dashboard-storage.service';
import { WorkersService } from '@qaroni-app/workers/services/workers.service';

@Component({
  selector: 'qaroni-menu-company',
  templateUrl: './menu-company.component.html',
  styleUrls: ['./menu-company.component.scss'],
  standalone: false,
})
export class MenuCompanyComponent {
  readonly user = input<User | null>(null);
  readonly companies = input<Company[]>([]);

  private router = inject(Router);
  private workersService = inject(WorkersService);
  private dasboardStorageService = inject(DashboardStorageService);

  goToCompanyDetails(company: Company) {
    this.dasboardStorageService.reset();
    const role = this.user()?.roles?.find(
      r => r.companyId === company.companyId
    );

    this.router.navigate(
      this.workersService.checkCompanyForRedirect(
        company?.companyId,
        role?.role,
        role?.employeeId
      )
    );
  }
}
